import './style.scss';
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useRef, useState } from 'react';
import { Link, useParams } from "react-router-dom";

import VisualGrid from "../../components/VisualGrid";
import Header from "../../components/Header";
import Footer from "../../components/Footer";

function App() {
  const [titleSrc, setTitleSrc] = useState("/images/mc-white.png");
  useEffect(() => {
    const updateTitleSrc = () => {
      if (window.innerWidth < 801) {       
        setTitleSrc("/images/mc-stacks-white.png");      
        return;
      }
      
      setTitleSrc("/images/mc-white.png");      
    };

    updateTitleSrc();
    window.addEventListener("resize", updateTitleSrc);
    return () => {
      window.removeEventListener("resize", updateTitleSrc);
    };
  }, []);

  return (
    <div className="mc-home">
      <VisualGrid />
      <section className="mc-home__content">       
        <section className="mc-home__sect">
          <Header />
          <div className="mc-home__poster">
            <div className="filmby">
              <p>A FILM BY &nbsp; R<span>'&nbsp;</span>TEJA BATHULA</p>
            </div>         
            <div className="title">
              <img src={titleSrc} />
            </div>
            <div className="few-lines">            
            </div>         
          </div>       
        </section>

        <section className="mc-home__teaser-wrap">       
          <div className="container">
            <div className="content-wrap">
              <div className="plot-theme">
                <p className="movie-details-label">A high-stakes political confrontation over one fateful night</p> 
                
                
              </div>
              <div className="cast-list">
                <p className="starring">STARRING</p>                                        
                <p className="cast">CHIP BRAY</p>
                <p className="cast">MUMBI KUGURU</p>
                <p className="cast">QUIRIJN DE LANG</p>
                <p className="cast">JOHN R. BULLEN</p>
                <p className="cast">MADALIENE SCHALET</p>
                <p className="cast">HANSJE G<span>ö</span>RTZ</p>
                <p className="cast">IBRAHIM KANJ</p>                                     
              </div>
            </div>
            <div className="poster">
              <img src="/images/Teaser-3.png" />            
            </div>
          </div>          
        </section>

        <section className="mc-home__teaser-wrap-mobile">       
          <div className="container">
            <div className="content-wrap">          
              <div className="cast-list">
                <p className="starring">STARRING</p>                                        
                <p className="cast">CHIP BRAY</p>
                <p className="cast">MUMBI KUGURU</p>
                <p className="cast">QUIRIJN DE LANG</p>
                <p className="cast">JOHN R. BULLEN</p>
                <p className="cast">MADALIENE SCHALET</p>
                <p className="cast">HANSJE G<span>ö</span>RTZ</p>
                <p className="cast">IBRAHIM KANJ</p>                                     
              </div>
            </div>           
          </div>          
        </section>   

        <section className="mc-home__teaser-video">
          <div className="container">
            <div className="video-label-container">
              <div className="label-wrap">
                <p>WATCH THE TEASER</p>
              </div>
            </div>
            <div className="video-container">
              <div className="iframe-container">
                <iframe src="https://www.youtube.com/embed/FCIBpa8jDcg?si=50awOA7PHsRHLKi-" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
              </div>         
            </div>
          </div>
        </section>     
      </section>
      <Footer />
    </div>
  );
}

export default App;